export default __webpack_public_path__ + "static/media/onboardingAsideMb.4264eeec.png";